export const SECURITE_LESSONS = [
  {
    id: 'securite-1',
    numero: 1,
    titre: "Créer un mot de passe solide",
    sousTitre: "Votre première protection",
    contexte: "Votre mot de passe est '123456' ou votre date de naissance. C'est le plus courant — et le plus dangereux.",
    explication: [
      "**Un mot de passe solide** fait au minimum 12 caractères et mélange majuscules, minuscules, chiffres et symboles.",
      "**La méthode des 3 mots** : choisissez 3 mots aléatoires et assemblez-les. 'Chapeau-Soleil-Grenouille7!' est très solide et facile à retenir.",
      "**Un mot de passe différent** pour chaque site important — surtout pour votre email, votre banque et vos espaces administratifs.",
      "**Ne notez jamais** vos mots de passe sur un post-it collé à l'écran. Utilisez un carnet rangé en lieu sûr ou une application de gestion de mots de passe.",
      "**Changez votre mot de passe** si vous pensez qu'il a été compromis — ou au moins une fois par an pour les comptes sensibles.",
    ],
    question: "Quel mot de passe est le plus solide ?",
    options: [
      { id: 'a', text: "Chapeau-Soleil-Grenouille7!", correct: true },
      { id: 'b', text: "Pierre1965", correct: false },
      { id: 'c', text: "123456", correct: false },
    ],
    explication_reponse: "'Chapeau-Soleil-Grenouille7!' est long, mémorisable et combine plusieurs types de caractères. 'Pierre1965' contient votre prénom et date de naissance — les pirates testent ces combinaisons en premier. '123456' est le mot de passe le plus piraté au monde.",
  },
  {
    id: 'securite-2',
    numero: 2,
    titre: "Reconnaître une arnaque en ligne",
    sousTitre: "Les signaux d'alarme",
    contexte: "Vous recevez un SMS : 'Votre colis est bloqué, payez 2€ pour le libérer'. Est-ce vrai ?",
    explication: [
      "**Les arnaques courantes** : faux colis bloqué, fausse amende impayée, faux remboursement de sécurité sociale, fausse mise à jour bancaire.",
      "**Les signaux d'alarme** : urgence artificielle ('agissez dans les 24h'), demande de paiement inhabituelle, lien bizarre, fautes d'orthographe.",
      "**La règle d'or** : les organismes officiels (La Poste, impôts, CPAM) ne demandent JAMAIS de paiement par SMS ou email.",
      "**En cas de doute** : ne cliquez sur aucun lien. Allez directement sur le site officiel en tapant l'adresse vous-même.",
      "**Signalez les arnaques** sur signal-spam.fr (emails) ou 33700 (SMS) — vous protégez les autres.",
    ],
    question: "Vous recevez un SMS 'La Poste : votre colis est bloqué, payez 2€ ici : [lien]'. Que faire ?",
    options: [
      { id: 'a', text: "Ignorer le SMS et vérifier sur le site officiel laposte.fr", correct: true },
      { id: 'b', text: "Payer les 2€, c'est une petite somme", correct: false },
      { id: 'c', text: "Appeler le numéro indiqué dans le SMS", correct: false },
    ],
    explication_reponse: "C'est une arnaque classique au faux colis. La Poste ne demande jamais de paiement par SMS. Ignorez le message et vérifiez votre suivi de colis directement sur laposte.fr avec votre numéro de suivi.",
  },
  {
    id: 'securite-3',
    numero: 3,
    titre: "Protéger ses données personnelles",
    sousTitre: "Ce que vous partagez en ligne",
    contexte: "Chaque formulaire en ligne vous demande des informations. Faut-il tout donner ?",
    explication: [
      "**Principe de minimisation** : ne donnez que les informations strictement nécessaires. Si un site vous demande votre date de naissance pour une newsletter, refusez.",
      "**Les champs obligatoires** sont marqués d'un astérisque *. Les autres sont optionnels — vous pouvez les laisser vides.",
      "**Vos données sensibles** : numéro de sécurité sociale, numéro de carte bancaire, mot de passe — ne les communiquez que sur des sites officiels et sécurisés (https).",
      "**Le cadenas 🔒** dans la barre d'adresse signifie que la connexion est sécurisée. Ne transmettez jamais de données sensibles sur un site sans cadenas.",
      "**Vos droits RGPD** : vous pouvez demander à tout site de supprimer vos données personnelles. C'est un droit garanti par la loi française.",
    ],
    question: "Comment savoir si un site est sécurisé avant de saisir vos informations ?",
    options: [
      { id: 'a', text: "Vérifier la présence du cadenas 🔒 dans la barre d'adresse", correct: true },
      { id: 'b', text: "Si le site a un beau design, il est sécurisé", correct: false },
      { id: 'c', text: "Tous les sites sont sécurisés aujourd'hui", correct: false },
    ],
    explication_reponse: "Le cadenas 🔒 (ou 'https' au début de l'adresse) indique que les données sont chiffrées entre vous et le site. Sans cadenas, vos informations transitent en clair et peuvent être interceptées. C'est le seul indicateur fiable.",
  },
  {
    id: 'securite-4',
    numero: 4,
    titre: "Que faire en cas de problème",
    sousTitre: "Les bons réflexes",
    contexte: "Vous pensez avoir été victime d'une arnaque ou que votre compte a été piraté. Que faire ?",
    explication: [
      "**Changez immédiatement** votre mot de passe du compte concerné — et de votre email si c'est lié.",
      "**Contactez votre banque** sans attendre si des données bancaires sont impliquées. Ils peuvent bloquer votre carte et surveiller les transactions.",
      "**Signalez à cybermalveillance.gouv.fr** — c'est le site officiel français d'aide aux victimes de cybercriminalité. Gratuit, disponible 24h/24.",
      "**Déposez plainte** à la police ou gendarmerie si vous avez subi un préjudice financier. Apportez toutes les preuves : screenshots, emails, relevés.",
      "**Prévenez vos proches** si votre compte email ou réseau social a été piraté — les escrocs envoient parfois des messages à vos contacts pour les arnaquer aussi.",
    ],
    question: "Vous avez cliqué sur un lien suspect et saisi votre mot de passe. Quelle est la première action ?",
    options: [
      { id: 'a', text: "Changer immédiatement le mot de passe du compte concerné", correct: true },
      { id: 'b', text: "Attendre de voir s'il se passe quelque chose", correct: false },
      { id: 'c', text: "Éteindre l'ordinateur et ne plus l'utiliser", correct: false },
    ],
    explication_reponse: "Changer le mot de passe immédiatement est la priorité absolue — avant que le pirate ne le fasse à votre place et ne vous bloque l'accès. Ensuite contactez votre banque si nécessaire et signalez sur cybermalveillance.gouv.fr.",
  },
];
